import React from "react";

import { Toggle } from "./Toggle";
export interface ToggleGroups {
  [group: string]: { name: string; title: string; text: string }[];
}
export const GroupedToggleList = React.memo(
  ({
    toggleGroups,
    selectedToggles,
    onChange,
  }: {
    toggleGroups: ToggleGroups;
    selectedToggles: string[];
    onChange: (selectedToggles: string[]) => void;
  }) => {
    const onIndividualToggleChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      const set = new Set(selectedToggles);
      if (event.target.checked) {
        set.add(event.target.name);
      } else {
        set.delete(event.target.name);
      }
      onChange(Array.from(set.values()));
    };

    return (
      <>
        {Object.entries(toggleGroups).map(([groupName, toggles], index) => (
          <div key={index} className="mb-2">
            <div className="block text-sm font-bold mb-2">{groupName}</div>
            {toggles.map(({ name, title, text }, index) => {
              return (
                <Toggle
                  key={index}
                  name={name}
                  title={title}
                  text={text}
                  onChange={onIndividualToggleChange}
                  isSelected={selectedToggles.includes(name)}
                />
              );
            })}
          </div>
        ))}
      </>
    );
  }
);
